export default __webpack_public_path__ + "static/media/Profile_04.bd1b11cd.JPG";